import videojs from 'video.js';
import { substituteShortcodes } from '../helpers/graphicOverlay';

export class TextOverlay extends videojs.getComponent('Component') {
  constructor(player, options = {}) {
    super(player, options);
    this.aLContext = options.aLContext;
    // This will allow the announcement of changes of placeholder videos
    // to assistive alongside the display of their text on screen
    this.el().setAttribute('aria-live', 'polite');
    this.el().classList.add('wrp-player-text-overlay');

    // TODO: Check why player:will-set-variant is triggered twice
    // requiring the clearing of the content during the `timeupdate`
    this.on(player, 'player:will-set-variant', (_, { variant }) => {
      // Instantly clear any existing prompt when the player changes variant
      this.clear();
      // But wait for the player to actually start playing the video
      // before displaying the new prompt, so it doesn't overlay above
      // the loading spinner, if it's a video that's playing
      if ((variant.is_placeholder && variant.image) || variant.embed_url) {
        this.update(variant);
      } else {
        this.one(player, 'play', () => {
          this.one(player, 'timeupdate', () => {
            this.clear();
            this.update(variant);
          });
        });
      }
    });
  }

  clear() {
    this.el().innerHTML = '';
  }
  update(variant = {}) {
    const el = this.el();
    el.setAttribute('data-prompt-style', variant?.prompt?.style);

    if (variant.text_overlay) {
      const parts = variant.text_overlay;

      if (parts.length) {
        const wrapper = document.createElement('div');
        wrapper.classList.add('wrp-player-text-overlay-content');

        for (const [partName, content] of parts) {
          // We don't want to add unnecessary elements to the page
          if (content) {
            const textElement = document.createElement('p');
            textElement.classList.add(`wrp-player-text-overlay-part--${partName}`);
            // Process shortcodes in the content with regex - to find [variable-varName] format shortcode in text and get varName
            const processedContent = substituteShortcodes(content, this.aLContext);

            textElement.textContent = processedContent;
            wrapper.appendChild(textElement);
          }
        }
        el.appendChild(wrapper);
      }
    }
  }
}
